
export default {
  props: ["cart"],
};
